/// <reference path="../../../../../../../../packages/q.TypeScript.DefinitelyTyped.0.7.8/Content/scripts/typings/q/q.d.ts" />
/// <reference path="../../../../../../../../packages/knockout.TypeScript.DefinitelyTyped.0.8.2/Content/Scripts/typings/knockout/knockout.d.ts" />
/// <reference path="../../../../../../../../packages/knockout.validation.TypeScript.DefinitelyTyped.0.3.6/Content/Scripts/typings/knockout.validation/knockout.validation.d.ts" />
/// <reference path="../../../../../../../../packages/FTW.Frontend.1.0.47/content/scripts/Ftw1.0.47/Ftw.d.ts" />
/// <reference path="../../../../../../../../packages/jquery.TypeScript.DefinitelyTyped.2.3.3/Content/Scripts/typings/jquery/jquery.d.ts" />
/// <reference path="../viewmodels/masterviewmodel.ts" /> 

module Elma {
    export class Init {
        constructor() {            
            //var masterViewModel = new Tapas.ViewModels.MasterViewModel();

            var config = new Ftw.FrameworkConfig();
            config.DebugMode = false;
            config.MasterViewModel = Elma.ViewModels.MasterViewModel; 
            ko.validation.locale('da-DK');
            config.ApiEndpoint = 'elma-api';
            Ftw.Base.init(config);    

        }
    } 
    
    //Example of creating an event 
    //export namespace Events {
    //        export var excel = new Ftw.Core.Event<any>('ExcelOrderLineAdded');
    //}
}
